/* Cadmas — Core JS */

/* ── Shop dropdown ─────────────────────────────────────── */
(function () {
  const trigger = document.querySelector('.nav-dropdown__trigger');
  const menu = document.querySelector('.nav-dropdown__menu');
  if (!trigger || !menu) return;

  function open() { trigger.setAttribute('aria-expanded', 'true'); menu.classList.add('open'); }
  function close() { trigger.setAttribute('aria-expanded', 'false'); menu.classList.remove('open'); }
  function toggle() { trigger.getAttribute('aria-expanded') === 'true' ? close() : open(); }

  trigger.addEventListener('click', (e) => { e.stopPropagation(); toggle(); });
  document.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* ── Mobile nav ────────────────────────────────────────── */
(function () {
  const nav = document.getElementById('mobile-nav');
  const overlay = document.getElementById('nav-overlay');
  const openBtn = document.getElementById('menu-btn');
  const closeBtn = document.getElementById('menu-close');
  if (!nav) return;

  function open() { nav.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close() { nav.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; }

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
})();

/* ── Search overlay ────────────────────────────────────── */
(function () {
  const overlay = document.getElementById('search-overlay');
  const backdrop = document.getElementById('search-backdrop');
  const openBtn = document.getElementById('search-btn');
  const closeBtn = document.getElementById('search-close');
  const input = document.getElementById('search-input');
  if (!overlay) return;

  function open() {
    overlay.classList.add('open');
    backdrop.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input?.focus(), 50);
  }
  function close() {
    overlay.classList.remove('open');
    backdrop.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  backdrop?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* ── Affiliate link + badge ─────────────────────────────── */
(function () {
  // BOTH routes give the 25%: the LINK applies the affiliate's code automatically,
  // and the customer can also type any affiliate's code at checkout.
  //
  // We store NOTHING client-side — no sessionStorage, no `ref` cart attribute. The
  // only persistence is Shopify's own: /discount/<code> attaches the code to the cart
  // server-side, where it lives for roughly two weeks. That is inherent to making a
  // link apply a discount and cannot be cleared from here.
  //
  // Attribution is decided by the code ON THE ORDER (portal: lib/process-order.mjs),
  // so whichever code is on the cart at checkout is who gets credit.
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (!ref) return;

  // handle → Shopify discount code. Must stay identical to codeForHandle()
  // in the portal's lib/affiliate-discount.mjs, which is what created the codes.
  const codeForHandle = (h) => String(h || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const code = codeForHandle(ref);

  // Apply the code, then land back here with ?ref intact so the badge still renders.
  // `ca` marks the post-redirect landing — without it this would redirect forever.
  if (code && !params.has('ca')) {
    params.set('ca', '1');
    const dest = window.location.pathname + '?' + params.toString();
    window.location.replace('/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(dest));
    return;
  }

  const badge = document.getElementById('affiliate-badge');
  const badgeText = document.getElementById('affiliate-badge-text');
  if (!badge || !badgeText) return;

  const name = ref.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  badgeText.textContent = 'Recommended by ' + name;
  badge.style.display = 'inline-flex';
})();

/* ── Gallery: unified carousel (mobile + desktop) ───────── */
(function () {
  const carousel = document.getElementById('gallery-swipe');
  if (!carousel) return;

  const items = carousel.querySelectorAll('.product-gallery__swipe-item');
  const dots = document.querySelectorAll('.product-gallery__dot');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');
  let current = 0;
  const total = items.length;

  let isProgrammaticScroll = false;

  function goTo(index) {
    if (index < 0 || index >= total) return;
    current = index;
    isProgrammaticScroll = true;
    carousel.scrollLeft = index * carousel.offsetWidth;
    requestAnimationFrame(() => { isProgrammaticScroll = false; });
    updateUI();
  }

  function updateUI() {
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
    thumbs.forEach((t, i) => t.classList.toggle('active', i === current));
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === total - 1;
  }

  prevBtn?.addEventListener('click', () => goTo(current - 1));
  nextBtn?.addEventListener('click', () => goTo(current + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));

  carousel.addEventListener('scroll', () => {
    if (isProgrammaticScroll) return;
    const closest = Math.round(carousel.scrollLeft / carousel.offsetWidth);
    if (closest !== current && closest >= 0 && closest < total) { current = closest; updateUI(); }
  }, { passive: true });

  carousel.setAttribute('tabindex', '0');
  carousel.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });

  updateUI();
  window.cadmasGalleryGoTo = goTo;
})();

/* ── Quantity selector ─────────────────────────────────── */
(function () {
  const input = document.getElementById('product-qty');
  const minus = document.getElementById('qty-minus');
  const plus = document.getElementById('qty-plus');
  if (!input) return;

  minus?.addEventListener('click', () => {
    const v = parseInt(input.value) || 1;
    if (v > 1) input.value = v - 1;
  });
  plus?.addEventListener('click', () => {
    const v = parseInt(input.value) || 1;
    input.value = v + 1;
  });
})();

/* ── Variant selection ────────────────────────────────── */
(function () {
  const options = document.querySelectorAll('.product-variants__option');
  const variantInput = document.getElementById('variant-id');
  const priceEl = document.getElementById('product-price');
  const addBtn = document.getElementById('add-to-cart');
  const stickyBtn = document.getElementById('sticky-add-to-cart');
  const variants = window.cadmasVariants || [];

  if (!options.length) return;

  let selectedOptions = [];

  // Init selected options from active buttons
  document.querySelectorAll('.product-variants__options').forEach(group => {
    const active = group.querySelector('.product-variants__option.active');
    if (active) selectedOptions.push(active.dataset.value);
  });

  function findVariant() {
    return variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  // Grey out option values that have no matching variant for the current selection
  function refreshOptionAvailability() {
    document.querySelectorAll('.product-variants__options').forEach(group => {
      group.querySelectorAll('.product-variants__option').forEach(btn => {
        const pos = parseInt(btn.dataset.option) - 1;
        const trial = selectedOptions.slice();
        trial[pos] = btn.dataset.value;
        const exists = variants.some(v => v.options.every((opt, i) => opt === trial[i]));
        btn.classList.toggle('product-variants__option--unavailable', !exists);
      });
    });
  }

  function updateUI(variant) {
    refreshOptionAvailability();

    // This colour/size combination does not exist — never leave a stale variant in the form
    if (!variant) {
      window.cadmasVariantMissing = true;
      window.cadmasPreorderActive = false;
      if (variantInput) variantInput.value = '';
      if (addBtn) {
        addBtn.textContent = 'Unavailable';
        addBtn.disabled = true;
        addBtn.classList.remove('product-purchase__add--preorder');
      }
      if (stickyBtn) {
        stickyBtn.textContent = 'Unavailable';
        stickyBtn.disabled = true;
        stickyBtn.classList.remove('btn--preorder');
      }
      const missingNote = document.getElementById('preorder-note');
      if (missingNote) missingNote.hidden = true;
      const missingStock = document.getElementById('product-stock');
      if (missingStock) { missingStock.hidden = true; missingStock.textContent = ''; }
      return;
    }
    window.cadmasVariantMissing = false;

    variantInput.value = variant.id;

    const price = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    if (priceEl) priceEl.textContent = price;

    const available = variant.available;
    const isBackorder = !!(window.cadmasProduct && window.cadmasProduct.tags &&
      (Array.isArray(window.cadmasProduct.tags)
        ? window.cadmasProduct.tags.indexOf('backorder') !== -1
        : String(window.cadmasProduct.tags).indexOf('backorder') !== -1));
    // Preorder can apply to the whole product, or to one option value (e.g. a single colour)
    const preorder = window.cadmasPreorder || {};
    const isPreorder = !!(preorder.product ||
      (preorder.option && variant.options && variant.options.indexOf(preorder.option) !== -1));
    window.cadmasPreorderActive = isPreorder;

    let label, stickyLabel, buyDisabled;
    if (isPreorder) {
      label = 'Preorder';
      stickyLabel = preorder.note ? `Preorder — ${preorder.note}` : 'Preorder';
      buyDisabled = true;
    }
    else if (available) { label = 'Add to Cart'; stickyLabel = `Add to Cart — ${price}`; buyDisabled = false; }
    else if (isBackorder) { label = 'Back Ordered'; stickyLabel = 'Back Ordered'; buyDisabled = true; }
    else { label = 'Sold Out'; stickyLabel = 'Sold Out'; buyDisabled = true; }

    if (addBtn) {
      addBtn.textContent = label;
      addBtn.disabled = buyDisabled;
      addBtn.classList.toggle('product-purchase__add--preorder', isPreorder);
    }
    if (stickyBtn) {
      stickyBtn.textContent = stickyLabel;
      stickyBtn.disabled = buyDisabled;
      stickyBtn.classList.toggle('btn--preorder', isPreorder);
    }

    const noteEl = document.getElementById('preorder-note');
    if (noteEl) noteEl.hidden = !isPreorder;

    // Stock line: meaningless for a preorder variant, so hide it there
    const stockEl = document.getElementById('product-stock');
    if (stockEl) {
      const qty = (window.cadmasStock || {})[String(variant.id)];
      stockEl.classList.remove('product-info__stock--low', 'product-info__stock--ok');
      if (isPreorder || typeof qty !== 'number' || qty <= 0) {
        stockEl.hidden = true;
        stockEl.textContent = '';
      } else if (qty <= 5) {
        stockEl.hidden = false;
        stockEl.classList.add('product-info__stock--low');
        stockEl.textContent = `Only ${qty} left in stock`;
      } else {
        stockEl.hidden = false;
        stockEl.classList.add('product-info__stock--ok');
        stockEl.textContent = 'In stock';
      }
    }
    if (variant.featured_image && window.cadmasGalleryGoTo) {
      const slot = (window.cadmasImageSlots && window.cadmasImageSlots[variant.featured_image.id] !== undefined)
        ? window.cadmasImageSlots[variant.featured_image.id]
        : (variant.featured_image.position - 1);
      window.cadmasGalleryGoTo(slot);
    }
  }

  options.forEach(btn => {
    btn.addEventListener('click', () => {
      const pos = parseInt(btn.dataset.option) - 1;
      const group = btn.closest('.product-variants__options');
      group.querySelectorAll('.product-variants__option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      selectedOptions[pos] = btn.dataset.value;

      const label = btn.closest('.product-variants').querySelector('[id^="selected-"]');
      if (label) label.textContent = btn.dataset.value;

      updateUI(findVariant());
    });
  });

  updateUI(findVariant());
})();

/* ── Product tabs ─────────────────────────────────────── */
(function () {
  const tabs = document.querySelectorAll('.product-tabs__tab');
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      document.querySelectorAll('.product-tabs__panel').forEach(p => p.classList.remove('active'));
      const panel = document.getElementById('tab-' + tab.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });
})();

/* ── Sticky CTA: hide when add-to-cart is visible ───── */
(function () {
  const addBtn = document.getElementById('add-to-cart');
  const sticky = document.getElementById('sticky-cta');
  if (!addBtn || !sticky) return;

  const observer = new IntersectionObserver(([entry]) => {
    sticky.style.display = entry.isIntersecting ? 'none' : '';
  }, { threshold: 0.5 });

  observer.observe(addBtn);

  document.getElementById('sticky-add-to-cart')?.addEventListener('click', () => {
    document.getElementById('product-form')?.requestSubmit();
  });
})();

/* ── Cart: intercept add and show feedback ────────────── */
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (window.cadmasPreorderActive || window.cadmasVariantMissing) return;
    const btn = document.getElementById('add-to-cart');
    const stickyBtn = document.getElementById('sticky-add-to-cart');
    const original = btn.textContent;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    const data = new FormData(form);

    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: data });
      if (!res.ok) throw new Error();

      btn.textContent = 'Added ✓';
      if (stickyBtn) stickyBtn.textContent = 'Added ✓';

      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
        if (stickyBtn) stickyBtn.textContent = original;
      }, 1500);

      // Update cart count in header
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const count = document.querySelector('.site-header__cart-count');
      if (count) count.textContent = cart.item_count;

    } catch {
      btn.textContent = 'Try again';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = original; }, 2000);
    }
  });
})();
